
import Header from "@/components/header/header.vue";
import {inject, shallowRef,ref} from 'vue'
import { useRoute,useRouter } from 'vue-router';
export default {
  components: {
    Header,
  },
  setup(){
     const route:any = useRoute();
    const router:any = useRouter();
     const $http: any = inject("$http");
    const activeNames = ref(['1']);
      let help_center = shallowRef([])
      let article_list = shallowRef([])
      $http.get_article_class().then((res:any)=>{
        console.log('res',res);
        if(res.code === 200){
           help_center.value = res.data[0].children
        }
      })
      $http.get_article_list({ size: 500,
        page: 1,}).then((res:any)=>{
           if(res.code === 200){
             article_list.value = res.data
           }
      })
      let fun_junk = (id:number)=>{
         router.push({
           name:'helpIII',
           params:{
             id:id,
           }
         })
      }
    return { 
      activeNames,
      help_center,
      article_list,
      fun_junk
       };
  }
}
